import axios from 'axios'
import { Message } from 'element-ui'
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { publicDataEncrypt } from '@/apis/commonApi'

// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
  headers: {
    "Content-Type": "application/json",
  },
})

const dataError = [
  '登录已失效,请重新登录',
  '您的账号已在其他设备登录,本机已登出',
  '用户未登录,无权限访问此接口',
]

// request interceptor
service.interceptors.request.use(
  config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
      config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改

    }
    if (config.url.indexOf('/bpis/common') > -1) {
      const match = config.url.match(/\/common\/.*/);
      const encryptData = publicDataEncrypt(match[0]);
      config.headers['requestUTC'] = encryptData.timestamp;
      config.headers['e-d'] = encryptData.encryptStr;
    }

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const { status, data, headers, request} = response;
    if (status === 200) {
      const { IsSuccess, Data, Token } = data
      
      if(Token) {
        Data.Token =  Token
      }
      if(request && (request.responseURL.indexOf('pmCmsSystemRelay') > -1 || request.responseURL.indexOf('couponSystemRelay') > -1)) {
        // 判断是否cms转发的接口
        if(data.dt || data.res === 1) {
          return data.dt || null
        } else {
          data.msg && Message({
            message: data.msg,
            type: 'error'
          })
          throw new Error(data.msg);
        }
      } if(request && (request.responseURL.indexOf('cmsApi/api/services') > -1 || request.responseURL.indexOf('cmsApi/File') > -1)) {
        // 判断是否西安CMS接口
        if(data.success && data.result) {
          if(data.result.succeeded === false) {
            data.result.message && Message({
              message: data.result.message,
              type: 'error'
            })
            throw new Error(data);
          } else {
            return data.result
          }
        } else {
          throw new Error(data.result);
        }
      } else if(headers && headers['content-type'].indexOf('image') > -1) {
        // 判断是否返回的图片
        return data
      } else if(data.msg === 'success!' && request.responseURL.indexOf('collect') > -1) {
        // 判断是否为CRM埋点接口
        return data
      } 
      else if (data.status == 0) {
        return data
      }

      else if (dataError.includes(Data)) {
        Message({
          message: Data,
          type: 'error'
        })
        deleteToken()
        throw new Error(Data);
      } 
      else if (data.content) {
        return data.content
      }

      else if (!IsSuccess) {
        if (!data.Data && data.message) {
          return data
        }
        else if (!Data && data.message) {
          Message({
            message: data.message,
            type: 'error'
          })
        }
        else if (!data.Data && !data.message){
          return data

        }
        else if (data.Data =='您不是沉眠用户，无法报名此活动'){
          throw new Error(data.Data);

        }
       
        else {
          Message({
            message: Data,
            type: 'error'
          })
        }
        throw new Error(Data);
      } else if (Data === 'success') {
        return data.data;
      } 
      else if(data.data==''){
        return data.data
      }
      else {
        // 需特殊处理的数据
        if(data.agentName) {
          return {
            agentName: data.agentName,
            Data 
          }
        } else if (data.countTotal) {
          return {
            countTotal: data.countTotal,
            ...Data
          }
        } else {
          return Data;
        }
      }
    } else {
      // throw new Error(data.msg);
    }
  },
  (error) => {
    console.log("请求出错：", error);
    // throw new Error(error);
  }
);

export function get(url, params = {}, headerConfig = null) {
  return service.get(
    url, 
    {
      params,
      headers: headerConfig ? headerConfig.headers : {},
    },
  )
}

export function getBolb(url, params = {}, headerConfig = null) {
  return service.get(
    url, 
    {
      params,
      headers: headerConfig ? headerConfig.headers : {},
      responseType: 'blob'
    },
  )
}

export async function post(url, data = {}, headerConfig = {}) {
  return await service.post(url, data, headerConfig)
}

export default service